'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _abyssReact = require('abyss-react');

var _abyssReact2 = _interopRequireDefault(_abyssReact);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

var _actions = require('../actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  messages: _propTypes2.default.object,
  wrapper: _propTypes2.default.string.isRequired,
  model: _propTypes2.default.string,
  parent: _propTypes2.default.string,
  validators: _propTypes2.default.object,
  field: _propTypes2.default.object.isRequired,
  parentField: _propTypes2.default.object.isRequired,
  modelValue: _propTypes2.default.any,
  value: _propTypes2.default.any,
  anchorRef: _propTypes2.default.object,
  setAnchorRef: _propTypes2.default.func,
  validateModel: _propTypes2.default.func
};

var defaultProps = {
  wrapper: 'div'
};

var connectState = function connectState(state, _ref) {
  var model = _ref.model,
      value = _ref.value,
      parent = _ref.parent;
  return {
    field: utils.getField(state, model),
    parentField: !parent ? {} : utils.getField(state, parent),
    modelValue: value || utils.getModelValue(state, parent || model)
  };
};

var methods = {
  setAnchorRef: function setAnchorRef(_ref2, ref) {
    var setRef = _ref2.setRef;

    setRef({ anchorRef: ref });
  },
  componentDidMount: function componentDidMount(_ref3) {
    var validateModel = _ref3.validateModel;

    validateModel();
  },
  componentWillUnmount: function componentWillUnmount(_ref4) {
    var dispatch = _ref4.dispatch,
        model = _ref4.model,
        validators = _ref4.validators;

    if (model && validators) {
      setTimeout(function () {
        return dispatch(actions.unset(model));
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(_ref5, prevProps) {
    var field = _ref5.field,
        anchorRef = _ref5.anchorRef,
        parent = _ref5.parent,
        parentField = _ref5.parentField,
        validateModel = _ref5.validateModel,
        model = _ref5.model;

    if (model) {
      var parentChanged = !parent ? false : parentField.validated === false || !(0, _isEqual2.default)(parentField.value, prevProps.parentField.value);

      if (anchorRef && field.focused) {
        anchorRef.focus();
      }

      if (field.validated === false || parentChanged) {
        validateModel();
      }
    }
  },
  validateModel: function validateModel(_ref6) {
    var dispatch = _ref6.dispatch,
        model = _ref6.model,
        modelValue = _ref6.modelValue,
        validators = _ref6.validators,
        parent = _ref6.parent;

    if (model && validators) {
      dispatch(actions.validate(model, modelValue, Object.assign({}, {
        errors: utils.getErrors(modelValue, validators)
      }, parent && {
        parent: parent.split('.').slice(1).join('.')
      })));
    }
  }
};

var ErrorMessage = function ErrorMessage(_ref7) {
  var children = _ref7.children,
      className = _ref7.className,
      messages = _ref7.messages,
      wrapper = _ref7.wrapper,
      field = _ref7.field,
      modelValue = _ref7.modelValue,
      setAnchorRef = _ref7.setAnchorRef,
      props = _objectWithoutProperties(_ref7, ['children', 'className', 'messages', 'wrapper', 'field', 'modelValue', 'setAnchorRef']);

  var appendScrollAnchor = !!(props.model && props.validators);

  delete props.value;
  delete props.model;
  delete props.modelValue;
  delete props.parent;
  delete props.parentField;
  delete props.validators;
  delete props.anchorRef;
  delete props.validateModel;

  if (!children && !(field.touched && field.changed)) {
    return null;
  }

  var errorProps = _extends({
    role: 'alert'
  }, props, {
    className: ['abyss-error-message', className].filter(function (c) {
      return c;
    }).join(' ')
  });

  if (children) {
    return _react2.default.createElement(wrapper, errorProps, children);
  }

  var message = Array.isArray(field.errors) ? utils.getErrorMessageArray(modelValue, messages, field.errors) : utils.getErrorMessage(modelValue, messages, field.errors);

  if (appendScrollAnchor) {
    message = _react2.default.createElement(
      'span',
      null,
      _react2.default.createElement('input', { key: 'input', style: { height: 0, width: 0 }, ref: setAnchorRef }),
      message
    );
  }

  return !message ? null : _react2.default.createElement(wrapper, errorProps, message);
};

ErrorMessage.propTypes = propTypes;
ErrorMessage.defaultProps = defaultProps;
ErrorMessage.connectState = connectState;
ErrorMessage.methods = methods;

exports.default = (0, _abyssReact2.default)(ErrorMessage);


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-form/lib/ErrorMessage/ErrorMessage.js
// module id = 564
// module chunks = 0